import React from 'react'
import { useHistory } from 'react-router-dom'

import { Portlet } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

import * as Tables from './tables'

const portletBreadcrumbs = [{ name: 'Promociones' }]

const ListaPage = () => {
  const history = useHistory()

  const clickNuevo = React.useCallback(() => {
    history.push(`/${CodigosTransaccionesConstant.PROMOCIONES_NUEVOACTUALIZAR}`)
  }, [history])

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Promociones'
          breadcrumbs={portletBreadcrumbs}
          buttons={[{ name: 'Nuevo', onClick: clickNuevo }]}
        />
        <Portlet.Body>
          <Tables.MainTable />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(ListaPage)
